import React from 'react';

export const DocumentIcon = () => (
    <img className="w-full h-full object-cover" src="https://api.builder.io/api/v1/image/assets/TEMP/dc07e89bcb906d052b90907e47e44087bd3428cc?width=240" alt="document preview" />
);
